<form id="gift-received-form" *ngIf="form && catalogGiftReceivedStoreFields" [formGroup]="form"
      [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="ui-g">
    <div class="ui-g-9 ui-md-9 ui-lg-9">
      <h1 *ngIf="giftReceivedHeadId" class="step-title">{{ 'common.edit' | translate }} {{ 'catalog.reservationCatalog' | translate }}</h1>
      <h1 *ngIf="!giftReceivedHeadId" class="step-title">{{ 'common.ts_ins' | translate }} {{ 'catalog.reservationCatalog' | translate }}</h1>
    </div>
    <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
      <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/catalog-gift-received-store"
              label="{{ 'common.back' | translate }}"></button>
      <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left"
              label="{{'common.save' | translate}}" [disabled]="articleInvalid || form.invalid"></button>
    </div>
  </div>
  <div class="card">
    <div class="ui-g ui-fluid">

      <!-- Negozi -->
      <div class="ui-g-12 ui-md-4">
        <span class="label"
              [ngClass]="{'required': !catalogGiftReceivedStoreFields.store_id.nullable}">{{ catalogGiftReceivedStoreFields.store_id.keyName }}</span>
        <!-- <p-dropdown
          [options]="giftStores"
          formControlName="store_id"
          [autoWidth]="false"
          [placeholder]="'common.store_title' | translate"
          [disabled]="loadGiftHead">
        </p-dropdown> -->
        <app-store-autocomplete
          formControlName="store_id"
          ngDefaultControl
          [selectedStore]="selectedStore"
          (selectedStoreChange)="changeStore($event)"
          [disabled]="loadGiftHead">
        </app-store-autocomplete>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form"
                            [validation]="catalogGiftReceivedStoreFields.store_id"></app-validation-msg>
      </div>


      <div class="ui-g ui-fluid">

        <!-- Data Ricezione -->
        <div class="ui-g-12 ui-md-6">
          <span class="label"
                [ngClass]="{'required': !catalogGiftReceivedStoreFields.dt_received.nullable}">{{ catalogGiftReceivedStoreFields.dt_received.keyName }}</span>
          <app-kv-calendar
            [inputName]="'dt_received'"
            [formData]="form"
            [defaultDate]="form.get('dt_received').value"
            [defaultValue]="form.get('dt_received').value"
            [disabled]="loadGiftHead">
          </app-kv-calendar>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form"
                              [validation]="catalogGiftReceivedStoreFields.dt_received"></app-validation-msg>
        </div>
      </div>
    </div>


    <div class="ui-g ui-fluid">

      <!-- Note -->
      <div class="ui-g-12 ui-md-4">
        <span class="label"
              [ngClass]="{'required': !catalogGiftReceivedStoreFields.ship_note.nullable}">{{ catalogGiftReceivedStoreFields.ship_note.keyName }}</span>
        <input type="text" pInputText class="fieldInput" formControlName="ship_note"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form"
                            [validation]="catalogGiftReceivedStoreFields.ship_note"></app-validation-msg>
    </div>

    <!-- Cataloghi -->
    <!--<div class="ui-g-12 ui-md-4">
      <span class="label"
          [ngClass]="{'required': !catalogField.id.nullable}">{{ catalogField.code.keyName }}</span>
      <p-dropdown
        [options]="catalogOption"
        formControlName="catalog_id"
        [autoWidth]="false"
        [placeholder]="'catalog.catalog' | translate"
        [disabled]="loadGiftHead">
      </p-dropdown>
      <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form"
                        [validation]="catalogGiftReceivedStoreFields.store_id"></app-validation-msg>
    </div>-->

  </div>

    <h3 class="title">{{ 'catalog.gift' | translate }}</h3>

    <div class="ui-g ui-fluid">

      <!-- Premi  -->
      <div formArrayName="giftItemRec" *ngIf="giftItemRec && giftItemRec.controls.length > 0 && itmFields">
        <div class="ui-g ui-fluid" *ngFor="let giftItm of giftItemRec.controls; let i=index" [formGroupName]="i">
          <p-panel class="ui-g-12">
            <p-header>
              <div class="ui-helper-clearfix pull-left">
                <h3 class="title">{{ '#' + (i+1) }}</h3>
              </div>
              <div class="ui-helper-clearfix pull-right" *ngIf="giftItm.get('num_assigned').value == 0">
                <button pButton type="button" (click)="removeGiftItemReceived(giftItm.get('id').value, i)" icon="fa fa-times"
                        class="ui-button-danger btnDelete"></button>
              </div>
            </p-header>

            <div class="ui-g ui-fluid">
              <div class="ui-g-12  ui-fluid">


                 <!-- Codice Articolo -->
                 <div class="ui-g-12 ui-md-4">
                  <span class="label"
                        [ngClass]="{'required': !itmFields.catalog_gift_itm_code.nullable}">{{ itmFields.catalog_gift_itm_code.keyName }}</span>
                    <p-autoComplete
                      formControlName="catalog_gift_itm_code"
                      [suggestions]="articleOption"
                      (completeMethod)="searchArticle($event)"
                      (onSelect)="onSelectArticle($event, i)"
                      (onClear)="onClearArticle()"
                      (onKeyUp)="articleInvalid = true"
                      placeholder="{{ 'campaign.itemCode' | translate }}"
                      [minLength]="2"
                      [required]="!itmFields.catalog_gift_itm_code.nullable"
                      field="label">
                      </p-autoComplete>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="giftItm"
                                      [validation]="itmFields.catalog_gift_itm_code"></app-validation-msg>
                </div>



                <!-- Quantità Ricevuta -->
                <div class="ui-g-12 ui-md-4">
                  <span class="label"
                        [ngClass]="{'required': !itmFields.num_received.nullable}">{{ itmFields.num_received.keyName }}</span>
                  <input type="number" pInputText class="fieldInput" formControlName="num_received"/>
                  <app-validation-msg [arrayValidators]="[validators.integerNotNegative, validators.numMin(giftItm.get('numMin').value)]" [(fireInvalidSubmit)]="invalidSubmit" [form]="giftItm" [validation]="itmFields.num_received"></app-validation-msg>
                </div>



                <!-- Quantità Assegnata -->
                <div class="ui-g-12 ui-md-4">
                  <span class="label"
                        [ngClass]="{'required': !itmFields.num_assigned.nullable}">{{ itmFields.num_assigned.keyName }}</span>
                  <input type="text" pInputText class="fieldInput" formControlName="num_assigned"  disabled="true"/>
                  <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="giftItm" [validation]="itmFields.num_assigned"></app-validation-msg>
                </div>
              </div>

            </div>
          </p-panel>
        </div>
      </div>
    </div>


     <div class="ui-g">
      <!-- Aggiungi Premi -->
      <div class="ui-g-12 ui-md-6">
        <button
          pButton
          (click)="addGiftItemReceived()"
          icon="fa fa-plus-circle"
          iconPos="right"
          type="button"
          class="k-generic-btn add-gift-item-btn"
          [disabled]="form.invalid"
          label="{{ 'common.add' | translate }}">
        </button>
      </div>
      <!-- Assegna Premi -->
      <div class="ui-g-12 ui-md-6" *ngIf="giftItemRec.controls.length > 0">
        <button
          id="assign-gift"
          pButton
          (click)="confirmGiftAssign()"
          icon="fa fa-plus-circle"
          iconPos="right"
          type="button"
          class="k-generic-btn"
          label="{{ 'loyalty.giftAssigned' | translate }}"
          [disabled]="articleOption.length == 0 || giftItemRec.invalid || articleInvalid">
        </button>
      </div>
    </div>
  </div>

</form>

<!-- Messaggio errore Articolo dulpicato-->
<p-confirmDialog width="425" key="duplicateAssignError"></p-confirmDialog>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-catalog-gift-received-store/loyalty-catalog-gift-received-store-detail/loyalty-catalog-gift-received-store-detail.component.html